module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0137.jpg?v=4921b8bb";